import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LOGO_URL } from '../lib/images';
import Footer from './Footer';

// Lightweight shell for public static pages (about, privacy, terms, contact).
// Shows a minimal branded header (no sidebar) so the pages are accessible to
// anyone — logged in or not — and crawlable by search engines.
export default function StaticPageLayout({ children, testId }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--bg)' }} data-testid={testId}>
      <header className="border-b" style={{ borderColor: 'var(--border)', background: 'var(--surface)' }}>
        <div className="max-w-6xl mx-auto px-6 sm:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 transition-opacity hover:opacity-80"
            data-testid="static-header-home-link">
            <img src={LOGO_URL} alt="Today" className="w-9 h-9 rounded-full" />
            <span className="font-bold text-lg" style={{ fontFamily: 'Manrope', color: 'var(--text)' }}>
              Today
            </span>
          </Link>
          <Link to="/" data-testid="static-header-back"
            className="inline-flex items-center gap-1.5 text-sm font-medium transition-colors"
            style={{ color: 'var(--muted-fg)' }}>
            <ArrowLeft className="w-4 h-4" /> Back to app
          </Link>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
